import { Station } from '@app/core/types/stations';
import { AuditMatchCategoryNavigator } from '../../components/AuditMatchCategoryNavigator';
import { MatchCategory } from '../matches-list/types';
import { ScheduleStatusSpotView } from './components/spot/ScheduleStatusSpotView';
import { ScheduleStatusMentionsView } from './components/mentions/ScheduleStatusMentionsView';

interface Props {
  readonly station: Station;
}

export function ScheduleStatusRootView({ station }: Props) {
  return (
    <div>
      <AuditMatchCategoryNavigator>
        {(category) =>
          category === MatchCategory.ADS ? (
            <ScheduleStatusSpotView station={station} />
          ) : (
            <ScheduleStatusMentionsView station={station} />
          )
        }
      </AuditMatchCategoryNavigator>
    </div>
  );
}
